import { flexCenterMobile, hideMobile } from 'routes/styl';
import styled from 'styled-components';
import fundo from 'assets/images/bglogin.svg';
import fundorosa from 'assets/images/fundorosa.svg';

export const ContainerBody = styled.div`
  background-image: 
    url(${fundo});
  background-position: 
    center center;
  background-repeat: 
    no-repeat;
  background-size: 
    cover;
  background-attachment: fixed;
  @media (max-width: 768px) {
    height: 100vh;
  }
`;

export const ContainerFooter = styled.div`
  background-image: 
    url(${fundorosa});
  background-position: 
    bottom -70px center;
  background-repeat: 
    no-repeat;
  background-attachment: fixed;
  width: 100vw;
  height: 100vh;
  position: fixed;
  bottom: 0;
  left: 0;
  pointer-events: none;
  @media (max-width: 768px) {
      background-position: 
    bottom -60px center;
  }
`;
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    max-width: 1366px;
    margin: 0 auto;
    @media (max-width: 768px) {
      height: auto;
    }
`;

export const Header = styled.header`
  padding: 1rem;
  text-align: center;
`;

export const Logo = styled.img`
  height: 50px;
  margin: 0 auto;
`;

export const Main = styled.main`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

export const Left = styled.div`
  flex: 1;
  position: relative;
  @media (max-width: 768px) {
    position: absolute;
    bottom: -100px;
    display: none;
  }
`;

export const Image = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  object-fit: cover;
`;

export const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  max-width: 500px;
  margin: 0 auto;
`;

// export const Full = styled.div`
//     background-image: url(${logo});
//     background-size: cover;
//     background-repeat: no-repeat;
//     background-position: center;
//     background-attachment: fixed;
//     background-color: red;
// `;

// export const Hr = styled.div`
//     background: var(--bg-hover-light);
//     height: 0.5rem;
// `;
// export const ContainerTemplateAuth = styled.div`
//     display: flex;
//     flex-direction: column;
    
//     justify-content: space-between;
//     min-height: calc(100vh - 0.5rem);
//     width: 100%;
//     max-width: 1600px;
//     margin: 0 auto;
//     & header {
//         display: flex;
//         justify-content: flex-end;
//         padding: 2.5rem 2.5rem 0;
//         ${flexCenterMobile}
//     }
// `;
// export const WarpTemplateAuth = styled.section.attrs({
//     className: 'warpTemplateAuth',
// })`
//     margin: 0 auto;
//     flex: 1;
//     display: flex;
//     & figure {
//         ${hideMobile}
//         img {
//             height: 100%;
//             object-fit: cover;
//             object-position: 20% 20%;
//             border-radius: 1rem;
//         }
//     }
//     width: 100%;
//     max-width: 550px;
//     @media (min-width: 991px) {
//         margin: 0 auto;
//         flex: none;
//         max-width: none;
//     }
//     .centerVertical {
//         display: flex;
//         align-items: center;
//         margin: 0 1.5rem;
//         width: 100%;
//         @media (min-width: 991px) {
//             width: auto;
//             display: grid;
//             grid-gap: 3rem;
//             grid-template-columns: 1fr max(32rem, 48rem);
//         }
//     }
// `;
